import axios from "axios";

export const adminGetEmailMkt = async (query) => {
  const url =
    axios.getUri({ url: "/api/admin/emailMkt", params: query }) ||
    `/api/admin/emailMkt`;
  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const sendEmailToUsers = async (data) => {
  const url = `/api/admin/emailMkt`;
  return axios(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};
